import {
    SET_IS_SAVE_DEFAULT_LOCATION,
} from "./DefaultLocationType";

const initialState = {
    isSaveDefaultLocation: null    
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_IS_SAVE_DEFAULT_LOCATION:
            return {
                ...state,
                isSaveDefaultLocation: action.isSaveDefaultLocation,
            };
        default:
            return state;
    }
};

export default reducer;
